import { render, staticRenderFns } from "./petMethod.vue?vue&type=template&id=3a32c8fc&scoped=true&"
import script from "./petMethod.vue?vue&type=script&lang=js&"
export * from "./petMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a32c8fc",
  null
  
)

export default component.exports